import { Stack, Pagination, Box } from '@mui/material';

const BAR_HEIGHT = 52;

export default function PaginationBar({ page, totalPages, onChange }) {
  return (
    <>
      {/* Spacer để table không bị che */}
      <Box sx={{ height: `${BAR_HEIGHT}px` }} />

      <Stack
        alignItems="center"
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          width: '100%',
          py: 1,
          bgcolor: 'white',
          borderTop: '1px solid #eee',
          zIndex: (theme) => theme.zIndex.appBar,
          height: `${BAR_HEIGHT}px`,
          boxSizing: 'border-box',
        }}
      >
        <Pagination
          page={page}
          count={totalPages}
          onChange={(_, p) => onChange(p)}
          size="small"
        />
      </Stack>
    </>
  );
}